<script setup lang="ts">
    import BaseToaster from '@/components/BaseToaster.vue';
    import Events from '@/services/Events';
    import { ref, onMounted, onUnmounted } from 'vue';
    import type { IToaster } from '@/typescript/interfaces/IToaster';

    const callToasterSymbol = ref();

    const toasters = ref<IToaster[]>([]);

    onMounted(() => {
        callToasterSymbol.value = Events.on('call-toaster', callToaster);
    });

    onUnmounted(() => {
        if (callToasterSymbol.value) {
            Events.off(callToasterSymbol.value, callToaster);
        }
    });

    function callToaster(toaster: IToaster) {
        toasters.value.unshift(toaster);
    }

    function closeToaster(index: number) {
        toasters.value.splice(index, 1);
    }
</script>

<template>
    <Teleport to="body">
        <div class="pointer-events-none absolute bottom-4 right-4 z-20 overflow-hidden p-4">
            <transition-group
                enter-active-class="animate-slide-in-bottom "
                leave-active-class="animate-slide-out-bottom"
                name="toasters-group"
                tag="div"
                class="flex flex-col gap-4"
            >
                <BaseToaster
                    v-for="(toaster, ind) in toasters"
                    :key="toaster.title"
                    :toaster
                    @close="closeToaster(ind)"
                />
            </transition-group>
        </div>
    </Teleport>
</template>
